import VueDocPreview from './App'
export default VueDocPreview
